<template>
    <div>
        <div v-if="parent_type == 'array' && data && data.length > 0">
            <div style="display: flex; align-items: center; gap: 10px;">
                <span>Tableau de</span>
                <b-select style="width: 142px" v-model="data[0].type" :options="[
                    {value: 'string', text: 'Texte'},
                    {value: 'number', text: 'Nombre'},
                    {value: 'boolean', text: 'Booléen'},
                    {value: 'object', text: 'Objet'},
                    {value: 'array', text: 'Tableau'},
                ]"></b-select>
                <b-checkbox v-if="data[0].type == 'string'" v-model="data[0].is_enum" @change="handleEnumChange(data[0])">Liste de valeurs</b-checkbox>
            </div>
            <div v-if="data[0].is_enum && data[0].enum" style="margin: 10px 0 10px 0; padding: 10px;">
                <div style="margin-bottom: 5px;">Valeurs</div>
                <draggable :list="data[0].enum" handle=".handle-enum">
                    <div v-for="(enumVal, enumIdx) in data[0].enum" :key="enumIdx" style="display: flex; align-items: center; margin-bottom: 5px;">
                        <b-button variant="link" size="sm" class="handle-enum" style="cursor: move;">
                            <i class="fas fa-grip-vertical"></i>
                        </b-button>
                        <b-input 
                            v-model="data[0].enum[enumIdx]"
                            style="flex: 1; margin-right: 5px;"
                            placeholder="Valeur"
                        />
                        <b-button variant="danger" size="sm" @click="removeEnumValue(data[0], enumIdx)">
                            <i class="fas fa-trash"></i>
                        </b-button>
                    </div>
                </draggable>
                <div style="display: flex; gap: 5px; margin-top: 10px;">
                    <b-button variant="success" size="sm" @click="addEnumValue(data[0])">
                        <i class="fas fa-plus"></i> Ajouter une valeur
                    </b-button>
                    <b-button variant="info" size="sm" @click="toggleBulkImport('array')">
                        <i class="fas fa-file-import"></i> Import multiple
                    </b-button>
                    <b-button variant="warning" size="sm" @click="openFileImport('array')">
                        <i class="fas fa-file-excel"></i> Import fichier
                    </b-button>
                    <b-button variant="secondary" size="sm" @click="sortEnumValues(data[0])">
                        <i class="fas fa-sort-alpha-down"></i> Trier A-Z
                    </b-button>
                </div>
                <div v-if="showBulkImport_array" style="margin-top: 10px; padding: 10px; background-color: #f8f9fa; border-radius: 4px;">
                    <b-form-textarea
                        v-model="bulkEnumInput_array"
                        placeholder="Une valeur par ligne..."
                        rows="3"
                        style="margin-bottom: 5px;"
                    ></b-form-textarea>
                    <b-button variant="primary" size="sm" @click="addBulkEnumValues(data[0])">
                        <i class="fas fa-check"></i> Importer
                    </b-button>
                    <b-button variant="secondary" size="sm" @click="showBulkImport_array = false" style="margin-left: 5px;">
                        <i class="fas fa-times"></i> Annuler
                    </b-button>
                </div>
            </div>
            <div v-if="data[0].type == 'object' || data[0].type == 'array'" style="margin-left:30px">
                <br />
                <json_schema_editor_value ref="editor" :parent_type="data[0].type" />
            </div>
        </div>
        <div v-else>
            <draggable :group="'json-schema-' + id" :list="data" class="list-group" handle=".handle">
                <b-card v-for="(item, idx) in data" :key="idx">
                    <div class="box">
                        <div class="box_left">
                            <b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
                            <b-input style="display:inline-flex; width: 142px" v-model="item.column"></b-input>&nbsp;
                            <b-select style="display:inline-flex; width: 142px" v-model="item.type" :options="[
                                {value: 'string', text: 'Texte'},
                                {value: 'number', text: 'Nombre'},
                                {value: 'boolean', text: 'Booléen'},
                                {value: 'object', text: 'Objet'},
                                {value: 'array', text: 'Liste'},
                        ]"></b-select>
                            <div v-if="item.type == 'string'" style="margin:10px">
                                <b-checkbox v-model="item.is_enum" @change="handleEnumChange(item)">Liste de valeurs</b-checkbox>
                            </div>
                        </div>
                        <div class="box_right">
                            <b-checkbox v-show="show_required" v-model="item.required">Obligatoire</b-checkbox>
                            <b-button variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
                        </div>
                    </div>
                    <div v-if="item.is_enum && item.enum" style="margin: 0 0 10px 30px; padding: 10px;">
                        <div style="margin-bottom: 5px;">Valeurs</div>
                        <draggable :list="item.enum" handle=".handle-enum">
                            <div v-for="(enumVal, enumIdx) in item.enum" :key="enumIdx" style="display: flex; align-items: center; margin-bottom: 5px;">
                                <b-button variant="link" size="sm" class="handle-enum" style="cursor: move;">
                                    <i class="fas fa-grip-vertical"></i>
                                </b-button>
                                <b-input 
                                    v-model="item.enum[enumIdx]" 
                                    style="flex: 1; margin-right: 5px;"
                                    placeholder="Valeur"
                                />
                                <b-button variant="danger" size="sm" @click="removeEnumValue(item, enumIdx)">
                                    <i class="fas fa-trash"></i>
                                </b-button>
                            </div>
                        </draggable>
                        <div style="display: flex; gap: 5px; margin-top: 10px;">
                            <b-button variant="success" size="sm" @click="addEnumValue(item)">
                                <i class="fas fa-plus"></i> Ajouter une valeur
                            </b-button>
                            <b-button variant="info" size="sm" @click="toggleBulkImport(idx)">
                                <i class="fas fa-file-import"></i> Import multiple
                            </b-button>
                            <b-button variant="warning" size="sm" @click="openFileImport(idx)">
                                <i class="fas fa-file-excel"></i> Import fichier
                            </b-button>
                            <b-button variant="secondary" size="sm" @click="sortEnumValues(item)">
                                <i class="fas fa-sort-alpha-down"></i> Trier A-Z
                            </b-button>
                        </div>
                        <div v-if="showBulkImports[idx]" style="margin-top: 10px; padding: 10px; background-color: #f8f9fa; border-radius: 4px;">
                            <b-form-textarea
                                v-model="bulkEnumInputs[idx]"
                                placeholder="Une valeur par ligne..."
                                rows="3"
                                style="margin-bottom: 5px;"
                            ></b-form-textarea>
                            <b-button variant="primary" size="sm" @click="addBulkEnumValues(item, idx)">
                                <i class="fas fa-check"></i> Importer
                            </b-button>
                            <b-button variant="secondary" size="sm" @click="$set(showBulkImports, idx, false)" style="margin-left: 5px;">
                                <i class="fas fa-times"></i> Annuler
                            </b-button>
                        </div>
                    </div>
                    <div v-if="item.type == 'object' || item.type == 'array'" style="margin-left:30px">
                        <json_schema_editor_value :ref="'editor-'+ idx" :parent_type="item.type" />
                    </div>
                </b-card>
            </draggable>
            <b-button variant="link" @click="add()"><i class="fas fa-plus"></i></b-button>
        </div>

        <!-- Modal pour l'import de fichier -->
        <b-modal v-model="showFileImportModal" title="Importer depuis un fichier" size="lg" @ok="confirmFileImport" @hidden="resetFileImport">
            <div>
                <b-form-group label="Fichier CSV ou XLSX">
                    <input type="file" ref="fileInput" @change="handleFileSelect" accept=".csv,.xlsx,.xls" class="form-control" />
                </b-form-group>
                
                <b-form-group v-if="fileColumns.length > 0" label="Sélectionnez la colonne à importer">
                    <b-select v-model="selectedColumn" :options="fileColumns" @change="previewColumnValues"></b-select>
                </b-form-group>
                
                <div v-if="previewValues.length > 0" style="margin-top: 15px;">
                    <strong>Aperçu des valeurs ({{ previewValues.length }} valeurs uniques) :</strong>
                    <div style="max-height: 200px; overflow-y: auto; border: 1px solid #ddd; padding: 10px; margin-top: 5px; background-color: #f8f9fa;">
                        <div v-for="(val, idx) in previewValues" :key="idx" style="padding: 2px 0;">
                            {{ val }}
                        </div>
                    </div>
                    <div style="margin-top: 10px;">
                        <strong>{{ newValuesCount }}</strong> nouvelle(s) valeur(s) sera(ont) ajoutée(s) (doublons ignorés)
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";
    import draggable from "vuedraggable";
    
    var clone = require("clone");

    export default {
        name: "json_schema_editor_value",
        components: {
            draggable
        },
        props: {
            columns: { default: () => [] },
            parent_type: {},
            show_required: {}
        },
        data: function () {
            return {
                data: [{column: "", type: "string", required: true}],
                id: uniqueId(),
                bulkEnumInput_array: "",
                bulkEnumInputs: {},
                showBulkImport_array: false,
                showBulkImports: {},
                showFileImportModal: false,
                fileColumns: [],
                selectedColumn: null,
                previewValues: [],
                fileData: [],
                currentImportTarget: null,
                currentImportIdx: null
            };
		},
        computed: {
            newValuesCount()
            {
                if (this.previewValues.length === 0) return 0;
                
                let targetItem;
                if (this.currentImportIdx === 'array') {
                    targetItem = this.data[0];
                } else if (this.currentImportIdx !== null && this.data[this.currentImportIdx]) {
                    targetItem = this.data[this.currentImportIdx];
                }
                
                if (!targetItem || !targetItem.enum) return this.previewValues.length;
                
                return this.previewValues.filter(val => !targetItem.enum.includes(val)).length;
            }
        },
		methods: {
            addEnumValue(item)
            {
                if (item.enum) {
                    item.enum.push("");
                }
            },
            toggleBulkImport(idx)
            {
                if (idx === 'array') {
                    this.showBulkImport_array = !this.showBulkImport_array;
                } else {
                    this.$set(this.showBulkImports, idx, !this.showBulkImports[idx]);
                }
            },
            addBulkEnumValues(item, idx)
            {
                if (!item.enum) {
                    return;
                }
                
                // Récupérer le texte du textarea approprié
                let text = '';
                if (idx !== undefined) {
                    text = this.bulkEnumInputs[idx] || '';
                } else {
                    text = this.bulkEnumInput_array || '';
                }
                
                if (!text.trim()) {
                    return;
                }
                
                // Séparer par lignes et nettoyer
                const lines = text.split('\n')
                    .map(line => line.trim())
                    .filter(line => line.length > 0);
                
                // Ajouter uniquement les valeurs qui n'existent pas déjà
                lines.forEach(line => {
                    if (!item.enum.includes(line)) {
                        item.enum.push(line);
                    }
                });
                
                // Vider le textarea après import
                if (idx !== undefined) {
                    this.$set(this.bulkEnumInputs, idx, '');
                    this.$set(this.showBulkImports, idx, false);
                } else {
                    this.bulkEnumInput_array = '';
                    this.showBulkImport_array = false;
                }
            },
            openFileImport(idx)
            {
                this.currentImportIdx = idx;
                this.showFileImportModal = true;
            },
            handleFileSelect(event)
            {
                const file = event.target.files[0];
                if (!file) return;

                const fileName = file.name.toLowerCase();
                
                if (fileName.endsWith('.csv')) {
                    this.parseCSV(file);
                } else if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) {
                    this.parseXLSX(file);
                } else {
                    alert('Format de fichier non supporté. Utilisez CSV ou XLSX.');
                }
            },
            parseCSV(file)
            {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const text = e.target.result;
                    const Papa = require('papaparse');
                    const result = Papa.parse(text, { header: true, skipEmptyLines: true });
                    
                    this.fileData = result.data;
                    this.fileColumns = result.meta.fields.map(field => ({ value: field, text: field }));
                    
                    if (this.fileColumns.length > 0) {
                        this.selectedColumn = this.fileColumns[0].value;
                        this.previewColumnValues();
                    }
                };
                reader.readAsText(file);
            },
            parseXLSX(file)
            {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const XLSX = require('xlsx');
                    const workbook = XLSX.read(data, { type: 'array' });
                    const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
                    const jsonData = XLSX.utils.sheet_to_json(firstSheet);
                    
                    this.fileData = jsonData;
                    
                    if (jsonData.length > 0) {
                        const columns = Object.keys(jsonData[0]);
                        this.fileColumns = columns.map(col => ({ value: col, text: col }));
                        
                        if (this.fileColumns.length > 0) {
                            this.selectedColumn = this.fileColumns[0].value;
                            this.previewColumnValues();
                        }
                    }
                };
                reader.readAsArrayBuffer(file);
            },
            previewColumnValues()
            {
                if (!this.selectedColumn || this.fileData.length === 0) {
                    this.previewValues = [];
                    return;
                }
                
                // Extraire les valeurs de la colonne sélectionnée
                const values = this.fileData
                    .map(row => row[this.selectedColumn])
                    .filter(val => val !== null && val !== undefined && val !== '')
                    .map(val => String(val).trim());
                
                // Obtenir les valeurs uniques
                this.previewValues = [...new Set(values)];
            },
            confirmFileImport()
            {
                if (this.previewValues.length === 0) {
                    return;
                }
                
                // Déterminer l'item cible
                let targetItem;
                if (this.currentImportIdx === 'array') {
                    targetItem = this.data[0];
                } else {
                    targetItem = this.data[this.currentImportIdx];
                }
                
                if (!targetItem || !targetItem.enum) {
                    return;
                }
                
                // Ajouter les valeurs qui n'existent pas déjà
                this.previewValues.forEach(value => {
                    if (!targetItem.enum.includes(value)) {
                        targetItem.enum.push(value);
                    }
                });
            },
            resetFileImport()
            {
                this.fileColumns = [];
                this.selectedColumn = null;
                this.previewValues = [];
                this.fileData = [];
                this.currentImportTarget = null;
                this.currentImportIdx = null;
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.value = '';
                }
            },
            removeEnumValue(item, idx)
            {
                if (item.enum) {
                    item.enum.splice(idx, 1);
                }
            },
            sortEnumValues(item)
            {
                if (item.enum && item.enum.length > 0) {
                    item.enum.sort((a, b) => {
                        // Convertir en string pour la comparaison
                        const aStr = String(a).toLowerCase();
                        const bStr = String(b).toLowerCase();
                        return aStr.localeCompare(bStr);
                    });
                    // Forcer la mise à jour de Vue
                    this.$set(item, 'enum', [...item.enum]);
                }
            },
            handleEnumChange(item)
            {
                if (item.is_enum) {
                    this.$set(item, 'enum', []);
                } else {
                    this.$delete(item, 'enum');
                }
            },
            load(data)
            {
                var self = this;
                this.data = data;

                console.log("data load json schema editor value")
                console.log(JSON.stringify(data))

                this.$nextTick(() => {
                    for (var i = 0; i < self.data.length; i++)
                    {
                        if (self.data[i].enum)
                            self.$set(self.data[i], 'is_enum', true);
                        if (self.data[i].type == 'object')
                        {
                            if (self.$refs["editor-" + i] && self.$refs["editor-" + i][0])
                                self.$refs["editor-" + i][0].load(self.data[i].obj);
                            else
                                self.$refs["editor"].load(self.data[i].obj);
                        }
                        else if (self.data[i].type == 'array')
                        {
                            if (self.$refs["editor-" + i] && self.$refs["editor-" + i][0])
                                self.$refs["editor-" + i][0].load(self.data[i].array);
                            else
                                self.$refs["editor"].load(self.data[i].array);
                        }
                    }
                })
            },
            save()
            {
                for (var i = 0; i < this.data.length; i++)
                {
                    if (this.data[i].type == 'object')
                    {
                        console.log("save obj editor-" + i);
                        if (this.$refs["editor-" + i] && this.$refs["editor-" + i][0])
                            this.data[i].obj = this.$refs["editor-" + i][0].save();
                        else
                            this.data[i].obj = this.$refs["editor"].save();
                    }
                    else if (this.data[i].type == 'array')
                    {

                        console.log("save array editor-" + i);
                        if (this.$refs["editor-" + i] && this.$refs["editor-" + i][0])
                            this.data[i].array = this.$refs["editor-" + i][0].save();
                        else
                            this.data[i].array = this.$refs["editor"].save();
                    }
                }

                return (this.data);
            },
            add()
            {
                this.data.push({column: "", type: "string", required: true})
            },
            del(idx)
            {
                this.data.splice(idx, 1);
            },
        },
		mounted: function () {
		}
    }

</script>

<style>
.box {
  display: flex;
  flex-direction: row;
}
.box_left
{
    padding: 10px;
    display: flex;
    align-items: center;
}
.box_right
{
  padding: 10px;
  display: flex;
  align-items: center;
  margin-left: auto;
}
</style>